import script from "./NotificationSettingMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationSettingMobile.vue?vue&type=script&setup=true&lang=js"

import "./NotificationSettingMobile.vue?vue&type=style&index=0&id=49049de7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49049de7"]])

export default __exports__